<template>
	<v-text-field
		:rules="internalRules"
		type="number"
		v-model.number="numericValue"
		:label="label"
		outlined
		clearable
	></v-text-field>
</template>
<script>
import {
	FieldRules
} from '@/components/';

export default {
	name: 'NumericInput',
	props: {
		value: {},
		rules: Array,
		greaterThan: {
			type: Number,
			default: Number.NaN
		},
		isRequired: {
			type: Boolean,
			default: false,
		},
		isFloat: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			required: true,
		},
	},
	computed: {
		numericValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
		internalRules() {
			const internalRules = [];
			const { requiredValid, greaterThanValid, floatValid } = FieldRules;

			if (this.isRequired) {
				const rule = (value) =>
					requiredValid(value) ||
					this.$t('common.required-field-message');
				internalRules.push(rule);
			}

			if (!isNaN(this.greaterThan)) {
				const rule = (value) =>
					greaterThanValid(this.greaterThan, value) ||
					this.$t('common.greater-than-field-message', { value: this.greaterThan });
				internalRules.push(rule);
			}

			if (this.isFloat) {
				const rule = (value) =>
					floatValid(value) ||
					this.$t('common.invalid-float-field-message');
				internalRules.push(rule);
			}

			if (this.rules && this.rules.length) {
				internalRules.push(...this.rules);
			}

			return internalRules;
		},
	},
};
</script>